import {
  InMemoryCache,
  IntrospectionFragmentMatcher,
  defaultDataIdFromObject,
} from 'apollo-cache-inmemory'

import introspectionQueryResultData from '../../generated/fragmentTypes.json'

export const createCache = () => {
  const fragmentMatcher = new IntrospectionFragmentMatcher({
    introspectionQueryResultData,
  })

  return new InMemoryCache({
    // Note: Not all GQL entities come with nice unique `id` fields.
    // Here we generate unique primary keys if needed.
    dataIdFromObject: (object: any) => {
      switch (object.__typename) {
        case 'RoundUpAccount':
          return `RoundUpAccount:${object.linkedSubaccountId}` // use `key` as the primary key
        case 'RoundUp':
          return `RoundUp:${object.transactionId}`
        case 'RoundUpProfile':
          return 'RoundUpProfile'
        case 'TierPrice':
          return null
        default:
          return defaultDataIdFromObject(object)
      }
    },
    fragmentMatcher,
  })
}
